export default __webpack_public_path__ + "3f6a5c42674f6f61745790203e7205f0.png";